var poll_header_default = {
  "title": "QTeN5",
  "image": "ZnwZp",
  "webview": "uNu3z"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
